import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

import styles from './dashboard.module.scss';

import payroll from 'assets/images/dashboard/payrollreports.png';
import managedeductions from 'assets/images/dashboard/managededuction.png';
import dollorinhand from 'assets/images/dashboard/dollorinhand.png';
import manageemployee from 'assets/images/dashboard/managecompany.png';
import timewatch from 'assets/images/dashboard/timewatch.png';
import managecompany from 'assets/images/dashboard/managecompany.png';
import receivepayment from 'assets/images/dashboard/receivepayment.png';
import payrollreports from 'assets/images/dashboard/payrollreports.png';
import useFeatures from 'hooks/useFeatures';
import sorter from 'assets/images/icon/sorter.png';
import filtersearch from "assets/images/icon/filter-search.png";
import filter from "assets/images/icon/filter-icon.png";
import PayrollsTable from './PayrollsTable';
import DashboardCharts from './DashboardCharts';
import { useQuery } from '@tanstack/react-query';
import { getCompany } from 'services/company';
import { SetupProgressCard } from 'components/CompanySetupChecklist';

const STATUS_OPTIONS = [
    { value: 'all',      label: 'All Payrolls' },
    { value: 'draft',    label: 'Draft' },
    { value: 'approved', label: 'Approved' },
    { value: 'void',     label: 'Void' },
];

const dashboardTiles = [
    { label: 'Start New Payroll',   icon: dollorinhand,    path: '/dashboard/start-new-payroll',                        featureKey: 'run_payroll' },
    { label: 'Manage Deductions',   icon: managedeductions, path: '/deductions',                                         featureKey: 'deductions' },
    { label: 'Manage Employee',     icon: manageemployee,  path: '/employees',                                          featureKey: 'manage_employees' },
    { label: 'Time & Attendance',   icon: timewatch,       path: '/dashboard/payroll-time-keeping',                     featureKey: 'time_attendance' },
    { label: 'Manage Contractor',   icon: manageemployee,  path: '/contractor',                                         featureKey: 'manage_contractors' },
    { label: 'Manage Company',      icon: managecompany,   path: '/dashboard/manage-company',                           featureKey: 'manage_company' },
    { label: 'Receive Payment',     icon: receivepayment,  path: '/dashboard/manage-company#withdrawal-bank-account',   featureKey: null },
    { label: 'Payroll Reports',     icon: payrollreports,  path: '/reports/all-reports',                                featureKey: 'reports' },
];

function Dashboard() {
    const navigate = useNavigate();
    const { hasFeature } = useFeatures();
    useQuery({ queryKey: ['company'], queryFn: getCompany });

    const [searchQuery,     setSearchQuery]     = useState('');
    const [showAmendments,  setShowAmendments]  = useState(false);
    const [statusFilter,    setStatusFilter]    = useState('all');
    const [showFilterMenu,  setShowFilterMenu]  = useState(false);

    const visibleTiles = dashboardTiles.filter(t => hasFeature(t.featureKey));

    return (
        <div className="content" style={{ padding: "16px 24px 16px 16px", backgroundColor: '#F8F9FA' }}>
            <div className='breadcrumb-section ms-3'>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Dashboard</li>
                    </ol>
                </nav>
                <h2 className='main-title mt-1'>Dashboard</h2>
            </div>
            <SetupProgressCard />
            <div className="row mt-5">
                {visibleTiles.map((tile, index) => (
                    <div key={index} className="col-xxl-3 col-lg-4 mb-4 dashboard-details-card" onClick={() => navigate(tile.path)}>
                        <div className='dashboard-details'>
                            <div className='d-flex align-items-center gap-3'>
                                <img src={tile.icon} alt={tile.label} />
                                <h2 className='card-title'>{tile.label}</h2>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <DashboardCharts />
            <div className='table-section mt-3'>
                <div className='filter-section d-flex align-items-center justify-content-between'>
                    <div>
                        <form onSubmit={e => e.preventDefault()}>
                            <div className="search-input">
                                <input
                                    type='text'
                                    placeholder="Search by pay period, type, status…"
                                    value={searchQuery}
                                    onChange={e => setSearchQuery(e.target.value)}
                                />
                                <img className="search-icon" src={filtersearch} alt="filtersearch" />
                            </div>
                        </form>
                    </div>
                    <div className='d-flex align-items-center gap-3'>
                        <div
                            className='d-flex align-items-center gap-3'
                            style={{ cursor: 'pointer', userSelect: 'none' }}
                            onClick={() => setShowAmendments(v => !v)}
                            title="Toggle amendment / correction payrolls"
                        >
                            <div className='active-status' style={{ background: showAmendments ? '#1B75F0' : undefined, transition: 'background 0.2s' }}></div>
                            <p className='amendment-title m-0' style={{ color: showAmendments ? '#1B75F0' : undefined }}>
                                Show Amendment Payrolls
                            </p>
                        </div>
                        <div style={{ position: 'relative' }}>
                            <div
                                className='filter-box d-flex align-items-center gap-3'
                                style={{ cursor: 'pointer', userSelect: 'none', background: statusFilter !== 'all' ? '#1B75F015' : undefined, borderColor: statusFilter !== 'all' ? '#1B75F0' : undefined }}
                                onClick={() => setShowFilterMenu(v => !v)}
                            >
                                <img className="search-icon" src={filter} alt="filter" />
                                <p className='amendment-title filter-payroll m-0' style={{ color: statusFilter !== 'all' ? '#1B75F0' : undefined }}>
                                    {statusFilter === 'all' ? 'Filter Payroll' : STATUS_OPTIONS.find(o => o.value === statusFilter)?.label}
                                </p>
                            </div>
                            {showFilterMenu && (
                                <div style={{
                                    position: 'absolute', right: 0, top: '110%', zIndex: 999,
                                    background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10,
                                    boxShadow: '0 4px 16px rgba(0,0,0,0.12)', minWidth: 160, overflow: 'hidden',
                                }}>
                                    {STATUS_OPTIONS.map(opt => (
                                        <div
                                            key={opt.value}
                                            onClick={() => { setStatusFilter(opt.value); setShowFilterMenu(false); }}
                                            style={{
                                                padding: '10px 16px', fontSize: 14, cursor: 'pointer',
                                                background: statusFilter === opt.value ? '#1B75F010' : '#fff',
                                                color: statusFilter === opt.value ? '#1B75F0' : '#374151',
                                                fontWeight: statusFilter === opt.value ? 600 : 400,
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.background = '#f3f4f6'}
                                            onMouseLeave={e => e.currentTarget.style.background = statusFilter === opt.value ? '#1B75F010' : '#fff'}
                                        >
                                            {opt.label}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <PayrollsTable
                    searchQuery={searchQuery}
                    showAmendments={showAmendments}
                    statusFilter={statusFilter}
                />
            </div>
        </div>
    );
}

export default Dashboard;
